import styled from "styled-components";

export const Header = styled.header`
    padding: 0 20px;
`;

export const Titulo = styled.h3`
    font-size: 24px;
    margin-bottom: 4px;
    margin-top: 0;
    font-weight: 500;
    line-height: 1.2;
    color: ${(props: any) => props.theme.colors.interfaceText};
`;

export const SubTitulo = styled.p`
    font-size: 14px;
    line-height: 20px;
    color: ${(props: any) => props.theme.colors.c64748b};
`;

export const TituloCartao = styled.h2`
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
    color: ${(props: any) => props.theme.colors.interfaceText};
`;

export const Cartao = styled.section`
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: auto;
    color: ${(props: any) => props.theme.colors.interfaceText400};
    word-wrap: break-word;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    background-clip: border-box;
    border: none;
    border-radius: 8px;
`;

export const CorpoCartao = styled.div`
    flex: 1 1 auto;
    padding: 24px 24px;
    color: ${(props: any) => props.theme.colors.interfaceText400};
`;

export const InformacaoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
`;

export const InformacaoRotulo = styled.label`
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.c64748b};
`;

export const InformacaoConteudo = styled.span`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color:${(props: any) => props.theme.colors.interfaceText};
`;

export const FormularioRotulo = styled.label<{ obrigatorio?: boolean }>`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${(props: any) => props.theme.colors.interfaceText};
    margin-bottom: 0.5rem;
    
    ${props => props.obrigatorio && `
        &::after {
            content: " *";
            color: ${(props: any) => props.theme.colors.primaryRed400};
        }
    `}
`;

const baseFormControl = `
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${(props: any) => props.theme.colors.c1e293b};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    background-clip: padding-box;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceBorder100};
    border-radius: 8px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;

export const FormularioControle = styled.input<{ erro?: boolean }>`
    ${baseFormControl}
    ${props => props.erro && `
        border-color: ${(props: any) => props.theme.colors.primaryRed400};
        &:focus {
            border-color: ${(props: any) => props.theme.colors.primaryRed400};
            box-shadow: 0 0 0 0.2rem rgba(229, 41, 64, 0.25);
        }
    `}
`;

export const FormularioAreaTexto = styled.textarea<{ erro?: boolean }>`
    ${baseFormControl}
    ${props => props.erro && `
        border-color: ${(props: any) => props.theme.colors.primaryRed400};
        &:focus {
            border-color: ${(props: any) => props.theme.colors.primaryRed400};
            box-shadow: 0 0 0 0.2rem rgba(229, 41, 64, 0.25);
        }
    `}
`;

export const FormularioGrupo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 16px;
`;

export const MensagemErro = styled.span`
    font-size: 12px;
    color: ${(props: any) => props.theme.colors.primaryRed400};
    margin-top: 4px;
`;

export const InputGrupo = styled.div`
    display: flex;
    gap: 16px;
`;

export const FormularioLinha = styled.div`
    display: flex;
    gap: 16px;
    
    > *:first-child {
        flex: 9;
    }
    
    > *:last-child {
        flex: 3;
    }
`;

export const FormularioGrupoLinha = styled(FormularioGrupo)`
    margin-bottom: 16px;
`;

export const Botao = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
    user-select: none;
    text-align: center;
`;

export const BotaoPrimario = styled(Botao)`
    background-color: ${(props: any) => props.theme.colors.primaryRed400};
    border-color: ${(props: any) => props.theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    &:hover {
        background-color: ${(props: any) => props.theme.colors.cc9243a};
        border-color: ${(props: any) => props.theme.colors.cc9243a};
    }
`;

export const BotaoMuted = styled(Botao)`
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    border-color: ${(props: any) => props.theme.colors.interfaceBorder100};
    color: ${(props: any) => props.theme.colors.c1e293b};
    &:hover {
        background-color: ${(props: any) => props.theme.colors.cf8f9fa};
    }
`;


export const Aside = styled.aside`
  grid-column: span 4;
`;

export const Main = styled.main`
  grid-column: span 8;
`;

export const AreaUpload = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  border: 2px dotted ${(props: any) => props.theme.colors.interfaceBorder100};
  border-radius: 8px;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
`;

export const UploadIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${(props: any) => props.theme.colors.ce5e7eb};
  color: ${(props: any) => props.theme.colors.c64748b};
  transition: all 0.2s ease;
`;

export const UploadTexto = styled.div`
  text-align: center;
`;

export const TextoPrincipal = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.interfaceText};
  margin: 0 0 4px 0;
`;

export const TextoSecundario = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.c64748b};
  margin: 0;
`;

export const ListaArquivos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`;

export const ItemArquivo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  height: auto;
  color: ${(props: any) => props.theme.colors.interfaceText400};
  word-wrap: break-word;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  background-clip: border-box;
  border: 1px solid ${(props: any) => props.theme.colors.ce5e7eb}; 
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ArquivoInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const ArquivoIcone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
`;

export const ArquivoDetalhes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ArquivoNome = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.interfaceText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const baseBadge = `
  display: inline-block;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: ${(props: any) => props.theme.colors.pureWhite};
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
`;

export const ArquivoTipo = styled.span`
  ${baseBadge}
  border-radius: 9999px !important;
  display: flex !important;
  align-items: center;
  border: 1px solid ${(props: any) => props.theme.colors.c64748b4d};
  color: ${(props: any) => props.theme.colors.c64748b} !important;
  font-weight: 600 !important;
  line-height: 16px !important;
  padding: 2px 10px !important;
`;

export const ArquivoMetadados = styled.div`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.c64748b};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ArquivoTamanho = styled.span`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.c64748b};
`;

export const BotaoRemover = styled(Botao)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: transparent;
  border: none;
  color: ${(props: any) => props.theme.colors.c64748b};
  font-size: 24px;
  line-height: 1;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cfee2e2};
    color: ${(props: any) => props.theme.colors.primaryRed400};
  }
`;

export const BotaoDownload = styled(Botao)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: 6px;
  color: ${(props: any) => props.theme.colors.c64748b};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cf1f5f9};
    color: ${(props: any) => props.theme.colors.interfaceText};
  }
`;

export const EmptyState = styled.div`
  padding: 24px;
  margin-top: 16px;
  text-align: center;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  border: 1px solid ${(props: any) => props.theme.colors.ce5e7eb};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const EmptyStateIcone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props: any) => props.theme.colors.c94a3b8};
`;

export const EmptyStateTitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.c64748b};
  margin: 0;
`;

export const EmptyStateText = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.c94a3b8};
  margin: 0;
`;


export const Divisor = styled.hr`
  margin: 8px 0;
  color: ${(props: any) => props.theme.colors.c94a3b8};
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
`;

export const EtiquetaTipoUsuario = styled.span`
    ${baseBadge}
    border-radius: 9999px !important;
    display: flex !important;
    align-items: center;
    background-color: ${(props: any) => props.theme.colors.ced354e1a} !important;
    border: 1px solid #0000;
    color: ${(props: any) => props.theme.colors.ced354e} !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    margin: 0px 0px 0px 4px;
    padding: 2px 10px !important;
`;

export const Skeleton = styled.div`
  background-color: ${(props: any) => props.theme.colors.ce0e0e0};
  border-radius: 4px;
  animation: shimmer 1.5s infinite linear;

  @keyframes shimmer {
    0% {
      background-color: ${(props: any) => props.theme.colors.ce0e0e0};
    }
    50% {
      background-color: ${(props: any) => props.theme.colors.cf0f0f0};
    }
    100% {
      background-color: ${(props: any) => props.theme.colors.ce0e0e0};
    }
  }
`;